<mat-card class="pageWrapper">
<mat-card-content>     
<h2 mat-dialog-title>User Access</h2>
    <mat-card>
            <div class="margin-top-20">
                <mat-form-field class="fullWidth" appearance="outline">
                    <mat-label>Email Id</mat-label>
                    <input matInput [(ngModel)]="emailId" >
                    
                </mat-form-field>
                <mat-form-field class="fullWidth driveid-matInput" appearance="outline">
                    <mat-label>Shared Drive Id</mat-label>
                    <input matInput [(ngModel)]="driveId">
                </mat-form-field>
                <button mat-raised-button (click)="fetchUser()" class="button-style">Search</button>

                <div class="list-grid-wrap home">
                    <span class="material-symbols-outlined" (click)="addUser()" matTooltip="Add new User">
                        <mat-icon>folder_shared</mat-icon>
                    </span>
                </div>
            </div>
            <div class="mat-elevation-z8 responsive-table-cont">
                <div class="responsive-table">
                    <table mat-table [dataSource]="dataSource" matSort>
                        <ng-container matColumnDef="driveId">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Drive Id
                            </th>
                            <td mat-cell *matCellDef="let element"> {{element.driveId}} </td>
                        </ng-container>
                        <ng-container matColumnDef="driveName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Drive Name
                            </th>
                            <td mat-cell *matCellDef="let element"> {{element.driveName}} </td>
                        </ng-container>
                        <ng-container matColumnDef="licenseType">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> License Type
                            </th>
                            <td mat-cell *matCellDef="let element"> {{element.licenseType}} </td>
                        </ng-container>
                        <ng-container matColumnDef="permType">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Perm Type
                            </th>
                            <td mat-cell *matCellDef="let element"> {{element.permType}} </td>
                        </ng-container>
                        <ng-container matColumnDef="role">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Role
                            </th>
                            <td mat-cell *matCellDef="let element"> {{element.role}} </td>
                        </ng-container>
                        <ng-container matColumnDef="userEmail">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Email
                            </th>
                            <td mat-cell *matCellDef="let element"> {{element.userEmail}} </td>
                        </ng-container>
                        <ng-container matColumnDef="userName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Name
                            </th>
                            <td mat-cell *matCellDef="let element"> {{element.userName}} </td>
                        </ng-container>
                        <ng-container matColumnDef="edit">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Edit
                            </th>
                            <td mat-cell *matCellDef="let element"> <mat-icon (click)="editUser(element)">edit</mat-icon> </td>
                        </ng-container>
                        <ng-container matColumnDef="delete">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Delete
                            </th>
                            <td mat-cell *matCellDef="let element"> <mat-icon (click)="deleteUser(element)">delete</mat-icon> </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>
                <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
                </mat-paginator>
            </div>
    </mat-card>
    
    </mat-card-content>

    
</mat-card>